import CalendarComponent from './CalendarComponent';

export default CalendarComponent;
